import { el } from "./lib/dom.js";
import { mountShell } from "./shell/Shell.js";
import css from "./shell/Shell.module.css";
import "./styles/global.css";
import { currentSyncUrl, currentWorkspaceId } from "./workspace/location.js";
import { openWorkspace } from "./workspace/open.js";

const container = document.getElementById("root");
if (container === null) throw new Error("missing #root");

const loading = el(
  "div",
  { class: css.loading ?? "", "data-role": "workspace-loading" },
  ["opening workspace…"],
);
container.appendChild(loading);

const syncUrl = currentSyncUrl();

openWorkspace(currentWorkspaceId(), syncUrl === undefined ? {} : { sync: syncUrl })
  .then((workspace) => {
    container.replaceChildren();
    mountShell(workspace, container);
  })
  .catch((error: unknown) => {
    container.replaceChildren(
      el("div", { class: css.loading ?? "", "data-role": "workspace-error" }, [
        `could not open workspace: ${error instanceof Error ? error.message : String(error)}`,
      ]),
    );
  });
